import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import { Trans } from '@lingui/react/macro';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export interface ErrorDisplayProps {
  title?: ReactNode;
  message?: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
}

export const ErrorDisplay = ({ title, message, actions, sx }: ErrorDisplayProps) => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%" p={3} flex={1} sx={sx}>
      <Stack direction="row" alignItems="center" gap={1} mb={1}>
        <Icon color="error" sx={{ display: 'block' }}>
          <ErrorOutlineIcon />
        </Icon>
        <Typography variant="h4" color="error" pt={0.8}>
          {title ?? <Trans>Something went wrong</Trans>}
        </Typography>
      </Stack>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {message}
      </Typography>
      {actions && (
        <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'center' }}>{actions}</Box>
      )}
    </Stack>
  );
};
